import React from 'react';
import { Stethoscope } from 'lucide-react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { TREATMENTS, SERVICES } from '../inquiry/constants';

export const InquiryStep2 = ({ errors, formData, handleChange, handleServiceToggle }) => (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center mx-auto mb-3">
          <Stethoscope className="w-6 h-6 text-white" />
        </div>
        <h3 className="font-semibold text-lg">Treatment & Services</h3>
        <p className="text-sm text-gray-500">What are you looking for?</p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="treatment">Treatment Category *</Label>
          <Select value={formData.treatment} onValueChange={(v) => handleChange('treatment', v)}>
            <SelectTrigger className={errors.treatment ? 'border-red-500' : ''} data-testid="inquiry-treatment">
              <SelectValue placeholder="Select treatment type" />
            </SelectTrigger>
            <SelectContent>
              {TREATMENTS.map(t => (
                <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {errors.treatment && <p className="text-xs text-red-500 mt-1">{errors.treatment}</p>}
        </div>

        <div>
          <Label htmlFor="medical_condition">Medical Condition (Optional)</Label>
          <Textarea
            id="medical_condition"
            placeholder="Briefly describe your medical condition or requirements..."
            value={formData.medical_condition}
            onChange={(e) => handleChange('medical_condition', e.target.value)}
            className="min-h-[80px]"
            data-testid="inquiry-condition"
          />
        </div>

        <div>
          <Label className="mb-2 block">Additional Services (Optional)</Label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {SERVICES.map(service => (
              <div
                key={service.value}
                onClick={() => handleServiceToggle(service.value)}
                className={`flex items-center gap-2 p-2 rounded-lg border cursor-pointer transition-all ${
                  formData.services.includes(service.value)
                    ? 'border-orange-500 bg-orange-50 text-orange-700'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <Checkbox
                  checked={formData.services.includes(service.value)}
                  className="pointer-events-none"
                />
                <span className="text-sm">{service.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
);
